import {
    HomeView,
    EntidadesView,
    EntidadView,
    CajasView,
    ControlProcesosView,
    AccesoCajasView,
    CierreTesoreriaView,
    RecaudacionImportacionView,
    RecaudacionControlView,
    RecaudacionConciliacionView,
    RecaudacionHistorialView,
    PublicacionHistorialView,
    BusquedaReciboPublicacionView,
    RendicionIngresosPublicosView,
    RendicionRegistroContableView,
    RendicionRegistroContableHistorialView,
    RendicionIngresosPublicosHistorialView,
    CierreCajasHistorialView,
    CierreCajasHistoriaDetallelView,
    DevolucionImportacionView,
    DevolucionConciliacionView,
    DevolucionHistorialView,
    DevolucionRendicionIngresosPublicosView,
    DevolucionRendicionRegistroContableView,
    DevolucionRendicionIngresosPublicosHistorialView,
    DevolucionRendicionRegistroContableHistorialView,
    UnauthorizedView,
    PageNotFoundView,

} from '../views';

import { TIPS } from "../consts/tips";
import { PERMISSIONS } from "../consts/permissions";

export const PrivateRoutes = [
  {
    index: 0,
    code: "home",
    path: "/",
    component: HomeView,
    tipName: TIPS.NAME.ROUTES.HOME_VIEW,
    title: "Home",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 10,
    code: "unauthorized",
    path: "/unauthorized",
    component: UnauthorizedView,
    title: "Unauthorized",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
    // VEPs
  {
    index: 60,
    path: "",
    component: null,
    title: "VEPs",
    showHeader: true,
    nivelMenu: 1,
    children: [61,62]
  },
  {
    index: 61,
    code: PERMISSIONS.RECAUDACION_LOTE_VIEW,
    path: "/busqueda/veps",
    component: BusquedaReciboPublicacionView,
    title: "Búsqueda de VEPs",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_HISTORIAL_VIEW,
  },
  {
    index: 62,
    code: PERMISSIONS.RECAUDACION_LOTE_VIEW,
    path: "/publicacion/historial",
    component: PublicacionHistorialView,
    title: "Historial de VEPs",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_HISTORIAL_VIEW,
  },
    // Cajas
  {
    index: 20,
    path: "",
    component: null,
    title: "Cajas",
    showHeader: true,
    nivelMenu: 1,
    children: [21,22,23,24],
  },
  {
    index: 21,
    code: PERMISSIONS.CAJA_VIEW,
    path: "/cajas",
    component: CajasView,
    title: "Administración de cajas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CAJAS_VIEW,
  },
  {
    index: 22,
    code: PERMISSIONS.CAJA_COBRO,
    path: "/acceso-cajas",
    component: AccesoCajasView,
    title: "Acceso a cajas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.ACCESO_CAJAS_VIEW,
  },
  {
    index: 23,
    code: PERMISSIONS.CIERRE_TESORERIA_EDIT,
    path: "/cierre-tesoreria",
    component: CierreTesoreriaView,
    title: "Cierre de tesorería",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CIERRE_TESORERIA_VIEW,
  },
  {
    index: 24,
    code: PERMISSIONS.CIERRE_TESORERIA_EDIT,
    path: "/historial/cierre-caja",
    component: CierreCajasHistorialView,
    title: "Historial de cierre de cajas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CIERRE_CAJAS_HISTORIAL_VIEW,
  },
  {
    index: 25,
    code: PERMISSIONS.CIERRE_TESORERIA_EDIT,
    path: "/historial/cierre-caja/:id",//["/cementerio/:mode", "/cementerio/:mode/:id"],
    component: CierreCajasHistoriaDetallelView,
    title: "Historial de cierre de cajas",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CIERRE_CAJAS_HISTORIAL_VIEW,
  }, 
    // Recaudacion
  {
    index: 30,
    path: "",
    component: null,
    title: "Recaudaciones",
    showHeader: true,
    nivelMenu: 1,
    children: [31,32,33,34],
  },
  {
    index: 31,
    code: PERMISSIONS.RECAUDACION_LOTE_EDIT,
    path: "/recaudacion/importacion",
    component: RecaudacionImportacionView,
    title: "Importación de recaudaciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_IMPORTACION_VIEW,
  },
  {
    index: 32,
    code: PERMISSIONS.RECAUDACION_LOTE_CONTROL,
    path: "/recaudacion/control",
    component: RecaudacionControlView,
    title: "Control de recaudaciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_CONTROL_VIEW,
  },
  {
    index: 33,
    code: PERMISSIONS.RECAUDACION_LOTE_CONCILICION,
    path: "/recaudacion/conciliacion",
    component: RecaudacionConciliacionView,
    title: "Conciliación de recaudaciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_CONCILIACION_VIEW,
  },
  {
    index: 34,
    code: PERMISSIONS.RECAUDACION_LOTE_VIEW,
    path: "/recaudacion/historial",
    component: RecaudacionHistorialView,
    title: "Historial de recaudaciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RECAUDACION_HISTORIAL_VIEW,
  },
    // Rendicion
  {
    index: 40,
    path: "",
    component: null,
    title: "Rendiciones",
    showHeader: true,
    nivelMenu: 1,
    children: [41,42,43,44],
  },
  {
    index: 41,
    code: PERMISSIONS.PAGO_RENDICION_EDIT,
    path: "/rendicion/ingresos-publicos",
    component: RendicionIngresosPublicosView,
    title: "Rendición a ingresos públicos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RENDICION_INGRESOS_PUBLICOS_VIEW,
  },
  {
    index: 42,
    code: PERMISSIONS.REGISTRO_CONTABLE_LOTE_EDIT,
    path: "/rendicion/contaduria",
    component: RendicionRegistroContableView,
    title: "Rendición a contaduría",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RENDICION_REGISTRO_CONTABLE_VIEW,
  },
  {
    index: 43,
    code: PERMISSIONS.REGISTRO_CONTABLE_LOTE_VIEW,
    path: "/rendicion/historial/contaduria",
    component: RendicionRegistroContableHistorialView,
    title: "Historial de rendición a contadurías",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RENDICION_REGISTRO_CONTABLE_HISTORIAL_VIEW,
  },
  {
    index: 44,
    code: PERMISSIONS.PAGO_RENDICION_VIEW,
    path: "/rendicion/historial/ingresos-publicos",
    component: RendicionIngresosPublicosHistorialView,
    title: "Historial de rendición a ingresos públicos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.RENDICION_INGRESOS_PUBLICOS_HISTORIAL_VIEW,
  },
    // Devoluciones
  {
    index: 45,
    path: "",
    component: null,
    title: "Devoluciones",
    showHeader: true,
    nivelMenu: 1,
    children: [71,72,73,74,75,76,77],
  },
  {
    index: 71,
    code: PERMISSIONS.DEVOLUCION_LOTE_EDIT,
    path: "/devolucion/importacion",
    component: DevolucionImportacionView,
    title: "Importación de devoluciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_IMPORTACION_VIEW,
  },
  {
    index: 72,
    code: PERMISSIONS.DEVOLUCION_LOTE_EDIT,
    path: "/devolucion/conciliacion",
    component: DevolucionConciliacionView,
    title: "Conciliación de devoluciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_CONCILIACION_VIEW,
  },
  {
    index: 73,
    code: PERMISSIONS.DEVOLUCION_LOTE_VIEW,
    path: "/devolucion/historial",
    component: DevolucionHistorialView,
    title: "Historial de devoluciones",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_HISTORIAL_VIEW,
  },
  {
    index: 74,
    code: PERMISSIONS.DEVOLUCION_LOTE_EDIT,
    path: "/devolucion/rendicion/ingresos-publicos",
    component: DevolucionRendicionIngresosPublicosView,
    title: "Rendición a ingresos públicos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_RENDICION_INGRESOS_PUBLICOS_VIEW,
  },
  {
    index: 75,
    code: PERMISSIONS.DEVOLUCION_LOTE_EDIT,
    path: "/devolucion/rendicion/contaduria",
    component: DevolucionRendicionRegistroContableView,
    title: "Rendición a contaduría",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_RENDICION_REGISTRO_CONTABLE_VIEW,
  },
  {
    index: 76,
    code: PERMISSIONS.DEVOLUCION_LOTE_VIEW,
    path: "/devolucion/rendicion/historial/ingresos-publicos",
    component: DevolucionRendicionIngresosPublicosHistorialView,
    title: "Historial de rendición a ingresos públicos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_RENDICION_INGRESOS_PUBLICOS_HISTORIAL_VIEW,
  },
  {
    index: 77,
    code: PERMISSIONS.DEVOLUCION_LOTE_VIEW,
    path: "/devolucion/rendicion/historial/contaduria",
    component: DevolucionRendicionRegistroContableHistorialView,
    title: "Historial de rendición a contaduría",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.DEVOLUCION_RENDICION_REGISTRO_CONTABLE_HISTORIAL_VIEW,
  },
    // Configuracion
  {
    index: 50,
    path: "",
    component: null,
    title: "Configuración",
    showHeader: true,
    nivelMenu: 1,
    children: [51, 53]
  },
  {
    index: 51,
    code: PERMISSIONS.LISTAS_TESORERIA_VIEW,
    path: "/entidades",
    component: EntidadesView,
    tipName: TIPS.NAME.ROUTES.LISTAS_VIEW,
    title: "Listas",
    showHeader: true,
    nivelMenu: 2,
    children: []
  },
  {
    index: 52,
    code: PERMISSIONS.LISTAS_TESORERIA_VIEW,
    path: "/entidad/:mode/:tipo",
    component: EntidadView,
    tipName: TIPS.NAME.ROUTES.ENTIDAD_FORM,
    title: "Entidad",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 53,
    code: "proceso_view",
    path: "/configuracion/control-procesos",
    component: ControlProcesosView,
    title: "Control de procesos",
    showHeader: true,
    nivelMenu: 2,
    children: [],
    tipName: TIPS.NAME.ROUTES.CONTROL_PROCESOS_VIEW,
  },
  {
    index: 999,
    code: "not-found",
    path: "*",
    component: PageNotFoundView,
    tipName: TIPS.NAME.ROUTES.NOT_FOUND,
    title: "Página no encontrada",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
];
